import { Button, Checkbox, Col, Form, Row, Typography } from "antd";
import appBarCode from "../../assets/appBarCode.png";
import { ReactComponent as SignUpDocIcon } from "../../assets/signupdocIcon.svg";
import { useForm } from "../../utils/hooks/useForm";
import "react-phone-input-2/lib/style.css";
import FloatInput from "../../components/FloatInput/floatInput";
import "./signin.modules.css";
import { Link, useNavigate } from "react-router-dom";
import SignUpDocMiniIcon from "../../assets/signupMiniIcon.webp";
import { useAuth } from "../../utils/hooks/useAuth";
import {
  emailPattenValidation,
  passwordPatternValidation,
} from "../../utils/methods/form-validations";
import WPLayout from "../../components/WPLayout/WPLayout";

const SignInV1 = () => {
  const navigate = useNavigate();
  const { form } = useForm();
  const { signin, isLoading } = useAuth(form);

  const onFinishFailed = (errorInfo: any) => {};

  const handleFinish = async (values: any) => {
    try {
      await signin(values);
    } catch (error) {
      onFinishFailed(error);
    }
  };

  return (
    <WPLayout>
      <div className="my-2 flex flex-col justify-center items-center px-6 py-4 w-full max-w-[1440px] mx-auto lg:gap-y-8">
        <div className="flex flex-col lg:flex-row justify-center items-center w-full lg:gap-x-20 lg:pl-10">
          <div className="hidden lg:flex lg:flex-col lg:gap-y-7 lg:justify-center lg:items-center lg:mb-auto lg:ml-2 lg:mt-10">
            <div className="flex flex-col gap-y-2 justify-center max-w-[390px]">
              <Typography.Text className="font-playfair font-bold text-[48px] leading-tight">
                Welcome to DocUpdate!
              </Typography.Text>
              <Typography.Text className="mt-6 font-urbanist font-bold text-[20px] tracking-[1%] leading-none">
                Sign in to manage your preferences and update your personal
                information.
              </Typography.Text>
              <Typography.Text className="font-urbanist font-medium text-lg text-[#050505]">
                Don't have an account?
                <span
                  className="text-[#7E5AE2] cursor-pointer font-bold"
                  onClick={() => navigate("/signup-new")}
                >
                  {" "}
                  Register Now
                </span>
              </Typography.Text>
              <div className="mt-2 w-full">
                <SignUpDocIcon className="object-cover w-[95%] h-full" />
              </div>
            </div>
          </div>
          <div className="lg:hidden flex flex-col gap-y-4 justify-center items-center mt-10">
            <Typography.Text className="font-playfair font-semibold text-[42px] leading-[120%] tracking-[-2%] text-center">
              Welcome to Docupdate
            </Typography.Text>
            <Typography.Text className="font-playfair font-semibold text-[15px] text-center">
              Sign in to manage your preferences and update your personal
              information.
            </Typography.Text>
            <Typography.Text className="font-urbanist font-medium text-base text-[#050505]">
              Don't have an account?
              <span
                className="text-[#7E5AE2] cursor-pointer font-bold"
                onClick={() => navigate("/signup-new")}
              >
                {" "}
                Register Now
              </span>
            </Typography.Text>
          </div>
          <div className="my-6 pt-2 flex flex-col w-full max-w-[470px] justify-center items-start rounded-xl mobile-m:rounded-3xl mobile-m:px-2 lg:my-0 lg:mt-8 gap-y-6">
            <Form
              form={form}
              name="signup"
              onFinish={handleFinish}
              onFinishFailed={onFinishFailed}
              className="pt-2 flex flex-col bg-white w-full max-w-[470px] justify-center items-center rounded-xl mobile-m:rounded-3xl mobile-m:px-2"
            >
              <div className="flex flex-col justify-center items-center max-w-[380px]">
                <Typography.Text className="font-playfair text-center text-3xl text-[#0F0F1C] font-bold">
                  Sign In
                </Typography.Text>
                <Typography.Text className="m-4 mb-0 font-urbanist text-center leading-4 text-[12px] text-normal text-[#5d6769] mobile-m:text-sm">
                  Welcome to DocUpdate. Please login to your account.
                </Typography.Text>

                <Row
                  gutter={[12, 12]}
                  className="px-5 xs:px-0 lg:!gap-y-5"
                  wrap
                  align={"middle"}
                  justify={"center"}
                >
                  <Col span={24} className="signin-col">
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "*Email Address is Required",
                        },
                        emailPattenValidation(),
                      ]}
                      validateFirst
                    >
                      <FloatInput
                        name={"email"}
                        type="text"
                        placeholder={"Email Address *"}
                        label="Email Address"
                        required={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24} className="signin-col">
                    <Form.Item
                      name="password"
                      rules={[
                        { required: true, message: "*Password is Required" },
                        passwordPatternValidation(),
                      ]}
                      validateFirst
                    >
                      <FloatInput
                        name="password"
                        type="password"
                        placeholder={"Enter Password *"}
                        label="Password"
                        required={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    span={24}
                    className="mt-3 xs:mt-0 flex justify-between items-center max-h-custom"
                  >
                    <Typography.Text
                      className="text-xs text-[#6c838a] cursor-pointer"
                      onClick={() => navigate("/forgot-password")}
                    >
                      Forget password?
                    </Typography.Text>
                    <Form.Item name="remember" valuePropName="checked">
                      <Checkbox className="mr-1 text-xs text-[#6c838a]">
                        Remember Me
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <Row className="w-full">
                  <Col span={24} className="text-center mt-2 lg:hidden">
                    <Typography.Text className="font-urbanist font-semibold text-sm text-[#050505]">
                      Don't have an account?
                      <span
                        className="text-[#7E5AE2] cursor-pointer font-bold"
                        onClick={() => navigate("/signup-new")}
                      >
                        {" "}
                        Register Now
                      </span>
                    </Typography.Text>
                  </Col>
                  <Col
                    span={24}
                    className="my-3 mb-6 px-4 flex justify-center items-center w-full md:px-2 lg:px-0 lg:mt-5"
                  >
                    <Button
                      htmlType="submit"
                      className="bg-[#7E5AE2] text-white border-none w-full font-semibold rounded-md text-sm"
                      loading={isLoading}
                      iconPosition="end"
                    >
                      Sign In
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
            <div className="hidden lg:flex flex-col gap-y-4">
              <Typography.Text className="font-bold text-lg font-poppins text-left w-full">
                Scan the QR code to download the app!
              </Typography.Text>
              <img
                src={appBarCode}
                className="ml-1 p-3 bg-white rounded-lg w-full max-w-32 app-bar-code-shadow"
              />
            </div>
          </div>
          <Link
            to={"https://docupdate.onelink.me/j4xR/desktop"}
            className="my-3 text-white text-base font-semibold font-inter py-2 px-4 bg-[#7e5ae2] rounded-full border-none transition-all duration-300 ease-in-out hover:bg-[#101935] flex justify-center items-center lg:hidden w-full max-w-[300px]"
          >
            Get the App
          </Link>
          <div className="mt-2 flex flex-col w-full h-full max-h-[318px] max-w-[430px] lg:hidden">
            <img
              src={SignUpDocMiniIcon}
              className="object-contain h-full w-[100%]"
            />
          </div>
        </div>
      </div>
    </WPLayout>
  );
};

export default SignInV1;
